import { render } from "./FaultContentCard.vue?vue&type=template&id=13f4cc02&scoped=true"
import script from "./FaultContentCard.vue?vue&type=script&lang=js"
export * from "./FaultContentCard.vue?vue&type=script&lang=js"

import "./FaultContentCard.vue?vue&type=style&index=0&id=13f4cc02&scoped=true&lang=scss"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f4cc02"]])

export default __exports__